import { Injectable } from '@angular/core';
import { BaseService } from '@app/shared/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CalendarEventService extends BaseService {
  constructor(protected http: HttpClient) {
    super('calendar-events', http);
  }

  getAllInRange<T>(startDate: Date, endDate: Date): Observable<T> {
    const params = new HttpParams()
      .set('start', startDate.toISOString())
      .set('end', endDate.toISOString());
    return this.http.get<T>(this.resourceUrl, { params });
  }
}
